import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const RegulationsWrapper = () => {
  const { t } = useTranslation("regulations")

  const pages = useMemo<PageLink[]>(() => {
    const tabs = [
      {
        label: t("lists.tabs.agec"),
        link: "agec",
      },
      {
        label: t("lists.tabs.rdue"),
        link: "rdue",
      },
      {
        label: t("lists.tabs.lca"),
        link: "lca",
      },
    ]
    return tabs
  }, [t])

  return <Page title={t("lists.title")} pages={pages} />
}
